import template from './room-type.jade';
import validation from './../../../services/validation';

export default angular.module('cian.addForm.roomType', []).directive('cianAfAboutObjectRoomType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'isSimpleFormEnabled',
    'deviceService',
    function ($scope, isSimpleFormEnabled, deviceService) {
      this.isSeveral = false;

      this.isMobile = deviceService.isMobile;

      this.validationRoomType = validation(this.form, 'roomType', {});

      const setValueFromModel = () => {
        this.checkboxType = {};

        if (this.ad.roomType === 'both') {
          this.checkboxType.separate = true;
          this.checkboxType.combined = true;
        } else if (this.ad.roomType === 'separate') {
          this.checkboxType.separate = true;
          this.checkboxType.combined = false;
        } else if (this.ad.roomType === 'combined') {
          this.checkboxType.separate = false;
          this.checkboxType.combined = true;
        } else {
          this.checkboxType.separate = false;
          this.checkboxType.combined = false;
        }
      };

      $scope.$watch(
        () => this.ad.roomsCount,
        () => {
          this.isSeveral = this.ad.roomsCount > 1;
          if (!this.isSeveral) {
            this.ad.roomType = undefined;
          }
          setValueFromModel();
        },
      );

      this.checkboxTypeChange = () => {
        if (this.checkboxType.separate && this.checkboxType.combined) {
          this.ad.roomType = 'both';
        } else if (this.checkboxType.separate) {
          this.ad.roomType = 'separate';
        } else if (this.checkboxType.combined) {
          this.ad.roomType = 'combined';
        } else {
          this.ad.roomType = undefined;
        }
      };

      this.isFieldVisible = () => {
        return this.isSeveral;
      };
    },
  ],
  controllerAs: '$ctrl',
  template,
})).name;
